import React from "react";
import { Link } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import Loading from "../../Loading/Loading";
import Footer from "../../SharePages/Footer/Footer";
import Navbar from "../../SharePages/Navbar/Navbar";
import SideNavBar from "../../SharePages/SideNavBar/SideNavBar";

import "./FailedBookingPanel/FailedBookingPanel.css";

const FlightChange = () => {
  const { loading } = useAuth();
  const comboFare = JSON.parse(sessionStorage.getItem("comboFare"));
  return (
    <div>
      <Navbar></Navbar>
      <SideNavBar></SideNavBar>
      <Loading loading={loading}></Loading>
      <div className="content-wrapper search-panel-bg">
        <section className="content-header"></section>
        <section className="content content-panel">
          <div className="container">
            <div className="row">
              <div className="col-lg-4"></div>
              <div className="col-lg-4 col-12 text-center bg-white">
                <h5 className="pt-4 fw-bold">Please try again</h5>
                <p>This fare has been changed </p>
                {JSON.parse(sessionStorage.getItem("uniqueTransID")) !==
                null ? (
                  <p>
                    Reference number :{" "}
                    {JSON.parse(sessionStorage.getItem("uniqueTransID"))}{" "}
                  </p>
                ) : (
                  <>
                    {comboFare !== null && (
                      <>
                        <p>
                          Reference number :{" "}
                          {comboFare && comboFare?.item[0]?.uniqueTransID}{" "}
                        </p>
                        <p>
                          Reference number :{" "}
                          {comboFare && comboFare?.item[1]?.uniqueTransID}{" "}
                        </p>
                      </>
                    )}
                  </>
                )}

                <div className="my-3">
                  <span className="text-danger fs-3">
                    <i
                      class="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    ></i>
                  </span>
                </div>
                <p>
                  Please contact the support team or try again<br></br>
                  Thank You
                </p>
                <hr></hr>
                <Link
                  to="/search"
                  className="btn button-color my-3 fw-bold border-radius"
                >
                  <span className="text-white">Search again</span>
                </Link>
              </div>
              <div className="col-lg-4"></div>
            </div>
          </div>
        </section>
      </div>
      <Footer></Footer>
    </div>
  );
};

export default FlightChange;
